// The cart mounts the same editor with an isolated product context.
let cartEmbroideryContext;
function embroideryRoot() { return cartEmbroideryContext?.root || document; }
function embroideryFrame() { return cartEmbroideryContext ? undefined : window.frameCustomization; }

window.loulouEmbroidery = {
    mount(root, save, close) {
        if (cartEmbroideryContext) this.unmount();
        const previous = { initialized: isModalInitialized, compatibility: embroideryCompatibilityData, draft: embroideryDraft, limit: lineOneLimit };
        cartEmbroideryContext = { root, save, close, previous };
        isModalInitialized = false;
        embroideryCompatibilityData = undefined;
        embroideryDraft = null;
        initEmbroidery();
    },
    unmount() {
        if (!cartEmbroideryContext) return;
        const previous = cartEmbroideryContext.previous;
        isModalInitialized = previous.initialized;
        embroideryCompatibilityData = previous.compatibility;
        embroideryDraft = previous.draft;
        lineOneLimit = previous.limit;
        cartEmbroideryContext = undefined;
    }
};

let isModalInitialized = false
let lineOneLimit = 3
let embroideryDraft;
let embroideryCompatibilityData;
let embroideryVariantListenerInitialized = false;
let embroiderySubmitGuardInitialized = false;

function normalizeEmbroideryCompatibilityValue(value) {
    return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}

function getEmbroideryCompatibilityData() {
    if (embroideryCompatibilityData) return embroideryCompatibilityData;
    const element = embroideryRoot().querySelector('#embroidery-compatibility-data');
    try {
        embroideryCompatibilityData = element ? JSON.parse(element.textContent) : {};
    } catch (error) {
        console.warn('Invalid embroidery compatibility configuration.', error);
        embroideryCompatibilityData = {};
    }
    embroideryCompatibilityData.categoryKeys = Array.isArray(embroideryCompatibilityData.categoryKeys) ? embroideryCompatibilityData.categoryKeys : [];
    embroideryCompatibilityData.rules = Array.isArray(embroideryCompatibilityData.rules) ? embroideryCompatibilityData.rules : [];
    return embroideryCompatibilityData;
}

function selectedEmbroideryCompatibilityKeys() {
    const selectedValues = [];
    const relevantOptionName = /(colou?r|pattern|print|background|material|fabric)/i;
    embroideryRoot().querySelectorAll('variant-picker input:checked, .variant-picker input:checked').forEach(input => {
        if (input.closest('product-add-ons')) return;
        const optionName = input.closest('[data-option-name]')?.dataset.optionName || input.closest('fieldset')?.dataset.optionName || '';
        if (relevantOptionName.test(optionName)) selectedValues.push(input.dataset.optionValueName || input.value);
    });
    const background = embroideryRoot().querySelector('.js-embroidery-background-color-option.selected input');
    if (background) selectedValues.push(background.value);
    const selectedKeys = selectedValues.map(normalizeEmbroideryCompatibilityValue).filter(Boolean);
    if (selectedKeys.length) return [...new Set(selectedKeys)];
    return getEmbroideryCompatibilityData().categoryKeys.map(normalizeEmbroideryCompatibilityValue).filter(Boolean);
}

function disabledEmbroideryFontKeys() {
    const selectedKeys = new Set(selectedEmbroideryCompatibilityKeys());
    const disabledFonts = new Set();
    getEmbroideryCompatibilityData().rules.forEach(rule => {
        const aliases = Array.isArray(rule.aliases) ? rule.aliases : [];
        const matches = [rule.key, rule.pattern, ...aliases]
            .map(normalizeEmbroideryCompatibilityValue)
            .some(key => key && selectedKeys.has(key));
        if (!matches) return;
        const fonts = Array.isArray(rule.disabledFonts) ? rule.disabledFonts : [];
        fonts.forEach(font => {
            const key = normalizeEmbroideryCompatibilityValue(font);
            if (key) disabledFonts.add(key);
        });
    });
    return disabledFonts;
}

function isEmbroideryFontRestricted(font) {
    const key = normalizeEmbroideryCompatibilityValue(font);
    return !!key && disabledEmbroideryFontKeys().has(key);
}

function updateEmbroideryFontPreview(option) {
    const input = option?.querySelector('input');
    const form = embroideryRoot().querySelector('#embroidery-form');
    if (!input || !form) return;
    const selector = form.dataset.isFrame === 'true'
        ? '.js-embroidery-text-preview-line-1, .js-embroidery-text-preview-line-2'
        : '.js-embroidery-text-preview';
    embroideryRoot().querySelectorAll(selector).forEach(preview => { preview.style.fontFamily = input.dataset.font; });
}

function applyEmbroideryFontRestrictions() {
    const options = Array.from(embroideryRoot().querySelectorAll('.js-embroidery-font-option'));
    if (!options.length) return;
    const disabledFonts = disabledEmbroideryFontKeys();
    options.forEach(option => {
        const input = option.querySelector('input');
        const disabled = disabledFonts.has(normalizeEmbroideryCompatibilityValue(input?.value));
        option.hidden = disabled;
        if (input) input.disabled = disabled;
        if (disabled && option.classList.contains('selected')) {
            option.classList.remove('selected');
            input.checked = false;
        }
    });
    let selected = options.find(option => option.classList.contains('selected') && !option.hidden);
    if (!selected) {
        selected = options.find(option => !option.hidden);
        if (selected) {
            selected.classList.add('selected');
            selected.querySelector('input').checked = true;
        }
    }
    if (selected) updateEmbroideryFontPreview(selected);
    const message = embroideryRoot().querySelector('.js-embroidery-font-restriction-message');
    if (message) {
        message.hidden = disabledFonts.size === 0;
        message.textContent = selected
            ? 'Some font styles are unavailable for the selected color or pattern.'
            : 'No font styles are available for the selected color or pattern.';
    }
}

function captureEmbroideryDraft(modal) {
    const fields = Array.from(modal.querySelectorAll('input, textarea, select'))
        .filter(node => !node.closest('product-add-ons'))
        .map(node => ({ node, value: node.value, checked: node.checked }));
    const presentation = Array.from(modal.querySelectorAll('[class*="js-embroidery-"], .embroidery-modal__preview-wrapper'))
        .filter(node => !node.closest('product-add-ons'))
        .map(node => ({ node, className: node.className, style: node.getAttribute('style'),
            html: node.matches('.js-embroidery-text-preview, .js-embroidery-text-preview-line-2') ? node.innerHTML : null }));
    return { fields, presentation };
}

function restoreEmbroideryDraft() {
    if (!embroideryDraft) return;
    embroideryDraft.fields.forEach(({ node, value, checked }) => { node.value = value; node.checked = checked; });
    initEmbroidery();
    embroideryDraft.presentation.forEach(({ node, className, style, html }) => {
        node.className = className;
        if (style === null) node.removeAttribute('style'); else node.setAttribute('style', style);
        if (html !== null) node.innerHTML = html;
    });
    applyEmbroideryFontRestrictions();
    enableSubmitButton();
}

function openEmbroideryModal() {
    const modal = embroideryRoot().querySelector('.embroidery-modal');
    if (!modal?.querySelector('#embroidery-form') || modal.classList.contains('open') || initEmbroidery() === false) return;
    const editing = embroideryRoot().querySelector('.js-product-form')?.classList.contains('embroidery-added');
    modal.dataset.editing = String(!!editing);
    const closeButton = modal.querySelector('.embroidery-modal__close');
    if (closeButton) closeButton.hidden = !!editing;
    const submit = modal.querySelector('.js-embroidery-submit');
    submit.dataset.addLabel ||= submit.textContent;
    submit.textContent = editing ? 'Update Customization' : submit.dataset.addLabel;
    embroideryDraft = captureEmbroideryDraft(modal);
    const body = document.body;
    if (modal) {
        modal.classList.add('open');
        body.style.overflow = 'hidden';
    }

    // scroll to top of the scrollable area
    const scrollableArea = modal.querySelector('.embroidery-form__scroll');
    const scrollableAreaMobile = modal.querySelector('.embroidery-form');

    scrollableArea.scrollTop = 0;
    scrollableAreaMobile.scrollTop = 0;


    window.productAddOns?.beginCustomization(embroideryRoot().querySelector('.js-product-form'));
}

function is_mobile() {
    return window.innerWidth < 1024
}

function closeEmbroideryModal(saved = false, cancelled = false) {
    if (cartEmbroideryContext) return cartEmbroideryContext.close();
    const modal = embroideryRoot().querySelector('.embroidery-modal');
    if (!saved && !cancelled && modal?.dataset.editing === 'true') return;
    if (!saved) restoreEmbroideryDraft();
    embroideryDraft = null;
    window.productAddOns?.finishCustomization(embroideryRoot().querySelector('.js-product-form'), saved);
    const body = document.body;
    if (modal) {
        modal.classList.remove('open');
        body.style.overflow = '';
    }
}

function checkUrlForEmbroideryOpen() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('embroidery')) {
        openEmbroideryModal();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    checkUrlForEmbroideryOpen();
});


function initEmbroidery() {
    if (!embroideryRoot().querySelector('#embroidery-form')) return false;


    const isFrame = embroideryRoot().querySelector('#embroidery-form').dataset.isFrame == 'true' ? true : false;
    const embroideryTextLine1 = isFrame ? embroideryRoot().querySelector('.js-embroidery-text-line-1') : null;
    const embroideryTextLine2 = isFrame ? embroideryRoot().querySelector('.js-embroidery-text-line-2') : null;
    const embroideryTextLine2Label = isFrame ? embroideryRoot().querySelector('.js-embroidery-text-line-2-label') : null;
    const embroideryTextWarning = isFrame ? embroideryRoot().querySelector('#embroidery-form .js-character-count-warning') : null;
    const embroideryText = isFrame ? null : embroideryRoot().querySelector('.js-embroidery-text');
    const maxCharacters = isFrame ? null : parseInt(embroideryText.maxLength);
    const embroideryPlacementOptions = isFrame ? null : embroideryRoot().querySelectorAll('.js-embroidery-placement-option');
    const embroideryColorOptions = embroideryRoot().querySelectorAll('.js-embroidery-color-option');
    const embroideryFontOptions = embroideryRoot().querySelectorAll('.js-embroidery-font-option');
    const embroideryBackgroundColorOptions = isFrame ? embroideryRoot().querySelectorAll('.js-embroidery-background-color-option') : null;
    const embroideryConsentCheckboxes = embroideryRoot().querySelectorAll('.js-embroidery-consent');
    const embroideryPreviewWrapper = embroideryRoot().querySelector('.embroidery-modal__preview-wrapper');
    const embroideryPreview = embroideryRoot().querySelector('.js-embroidery-text-preview');
    const embroideryPreviewBackground = isFrame ? embroideryRoot().querySelector('.embroidery-modal__preview-wrapper') : null;
    const embroideryPreviewLine1 = isFrame ? embroideryRoot().querySelector('.js-embroidery-text-preview-line-1') : null;
    const embroideryPreviewLine2 = isFrame ? embroideryRoot().querySelector('.js-embroidery-text-preview-line-2') : null;
    // Disabled product.metafields.custom.add_on
    // const embroideryAddOnOptions = isFrame ? embroideryRoot().querySelectorAll('.js-embroidery-add-on-option') : null;
    // const embroideryAddOnPreview = isFrame ? embroideryRoot().querySelector('.js-embroidery-add-on-preview') : null;
    const productForm = embroideryRoot().querySelector('.js-product-form');
    const mainPicker = Array.from(embroideryRoot().querySelectorAll('variant-picker, .variant-picker')).find(picker =>
        !picker.closest('product-add-ons') && (!picker.hasAttribute('form-id') || picker.getAttribute('form-id') === productForm?.getAttribute('id')));
    const selectedVariant = mainPicker?.querySelector('.variant-picker__option-values input:checked');
    const selectedVariantLabel = selectedVariant && Array.from(mainPicker.querySelectorAll('label')).find(label => label.htmlFor === selectedVariant.id);
    const defaultVariantResolved = !mainPicker && !!productForm?.querySelector('[name="id"]')?.value;
    if (isFrame && (!productForm?.querySelector('[name="id"]')?.value ||
        (!defaultVariantResolved && (!selectedVariantLabel || !selectedVariantLabel.hasAttribute('data-max-characters-line1'))))) {
        const wrapper = embroideryRoot().querySelector('.embroidery-btn-wrapper');
        let message = wrapper?.querySelector('[data-frame-selection-error]');
        if (wrapper && !message) {
            message = document.createElement('p');
            message.dataset.frameSelectionError = '';
            message.className = 'text-sm text-error';
            message.setAttribute('role', 'alert');
            wrapper.append(message);
        }
        if (message) message.textContent = 'Please select a product option before customizing.';
        const submit = embroideryRoot().querySelector('.js-embroidery-submit');
        if (submit) submit.disabled = true;
        mainPicker?.scrollIntoView({ block: 'center' });
        return false;
    }
    embroideryRoot().querySelector('[data-frame-selection-error]')?.remove();
    const maxCharactersLine1Limit = isFrame ? (selectedVariantLabel?.dataset.maxCharactersLine1 ?? embroideryTextLine1.maxLength) : null;
    const maxCharactersLine2Limit = isFrame ? (selectedVariantLabel?.dataset.maxCharactersLine2 ?? embroideryTextLine2.maxLength) : null;
    const maxCharactersWarningMessage = isFrame ? selectedVariantLabel?.dataset.maxCharactersWarningMessage : null;
    lineOneLimit = maxCharactersLine1Limit
    applyEmbroideryFontRestrictions();

    if(isFrame) {

        embroideryPreviewWrapper.classList.add('is-frame');
        embroideryTextLine1.maxLength = maxCharactersLine1Limit;
        embroideryTextLine2.maxLength = maxCharactersLine2Limit;

        embroideryTextLine1.placeholder = 'Enter your custom text (max ' + maxCharactersLine1Limit + ' characters)';
        embroideryRoot().querySelector('.js-embroidery-text-error').textContent = `Please enter valid text (max ${maxCharactersLine1Limit} characters).`;
        embroideryRoot().querySelector('.js-embroidery-text-error-line-2').textContent = `Please enter valid text (max ${maxCharactersLine2Limit} characters).`;

        if(maxCharactersWarningMessage) {
            embroideryTextWarning.textContent = maxCharactersWarningMessage;
            embroideryTextWarning.style.display = 'block';
        } else {
            embroideryTextWarning.style.display = 'none';
        }


        if(parseInt(maxCharactersLine2Limit) == 0) {
            embroideryTextLine2.style.display = 'none';
            embroideryTextLine2Label.style.display = 'none';
            embroideryTextLine2.value = '';
        } else {
            embroideryTextLine2.style.display = 'block';
            embroideryTextLine2Label.style.display = 'block';
            embroideryTextLine2.placeholder = 'Enter your custom text (max ' + maxCharactersLine2Limit + ' characters)';
        }

        // Listeners only setup once
        if (!isModalInitialized){
            embroideryTextLine1.addEventListener('input', () => {

                const text = embroideryTextLine1.value;
                embroideryPreviewLine1.textContent = text;

                displayTextValid()
                enableSubmitButton()

                if (lineOneLimit <= 3){

                    if (is_mobile()){
                        embroideryPreviewLine1.style.fontSize = `${ 100 - (text.length * 5)}px`;
                    }
                    else {
                        embroideryPreviewLine1.style.fontSize = `${ 250 - (text.length * 30)}px`;
                    }
                }
                else {
                    embroideryPreviewLine1.style.fontSize = "52px";
                }

            });

            embroideryTextLine2.addEventListener('input', () => {
                const text = embroideryTextLine2.value;
                embroideryPreviewLine2.textContent = text;
                displayTextValid();
                enableSubmitButton();
            });

            embroideryBackgroundColorOptions.forEach(option => {
                option.addEventListener('click', () => {
                    embroideryBackgroundColorOptions.forEach(opt => opt.classList.remove('selected'));
                    option.classList.add('selected');
                    const input = option.querySelector('input');
                    const imageUrl = input.dataset.image;
                    const color = input.dataset.color;
                    if (imageUrl) {
                        embroideryPreviewBackground.style.backgroundImage = `url(${imageUrl})`;
                        embroideryPreviewBackground.style.backgroundSize = 'cover';
                        embroideryPreviewBackground.style.backgroundPosition = 'center';
                        embroideryPreviewBackground.style.backgroundColor = '';
                    } else if (color) {
                        embroideryPreviewBackground.style.backgroundImage = '';
                        embroideryPreviewBackground.style.backgroundColor = color;
                    }
                    applyEmbroideryFontRestrictions();
                    enableSubmitButton();
                });
            });
        }

        
        // Disabled product.metafields.custom.add_on
        // embroideryAddOnOptions.forEach((option, index) => {
        //     option.addEventListener('click', () => {
        //         embroideryAddOnOptions.forEach(opt => opt.classList.remove('selected'));
        //         option.classList.add('selected');
        //         if(option.querySelector('input').value == 'none') {
        //             embroideryAddOnPreview.style.backgroundImage = '';
        //             embroideryPreviewWrapper.classList.remove('has-add-on');
        //         } else {
        //             embroideryAddOnPreview.style.backgroundImage = `url(${option.querySelector('.js-add-on-label').querySelector('img').src})`;
        //             embroideryPreviewWrapper.classList.add('has-add-on');
        //         }
        //     });
        // });
    } else {

        // Listeners only setup once
        if (!isModalInitialized) {

            embroideryText.addEventListener('input', () => {
                const text = embroideryText.value;
        
                if(maxCharacters > 15) {
                    const textLines = text.split(' ');
                    let line1 = '';
                    let line2 = '';
                    for(let i = 0; i < textLines.length; i++) {
                        if(line1.length + textLines[i].length <= 15) {
                            line1 += textLines[i] + ' ';
                        } else {
                            line2 = textLines.slice(i).join(' ');
                            break;
                        }
                    }
                    
                    embroideryPreview.replaceChildren(document.createTextNode(line1), document.createElement('br'), document.createTextNode(line2));
                } else {
                    embroideryPreview.textContent = text;
                }
        
                enableSubmitButton();
            });
        }

        
        if(embroideryPlacementOptions) {
            embroideryPlacementOptions.forEach(option => {
                option.addEventListener('click', () => {
                    embroideryPlacementOptions.forEach(opt => opt.classList.remove('selected'));
                    option.classList.add('selected');
                });
            });
        }

        
    }

    // Sections used by both versions

    if (!isModalInitialized){
        embroideryColorOptions.forEach(option => {
            if(option.classList.contains('selected')) {
                if(isFrame) {
                    embroideryPreviewLine1.style.color = option.querySelector('input').dataset.color;
                    embroideryPreviewLine2.style.color = option.querySelector('input').dataset.color;
                } else {
                    embroideryPreview.style.color = option.querySelector('input').dataset.color;
                }
            }
            option.addEventListener('click', () => {
                embroideryColorOptions.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                if(isFrame) {
                    embroideryPreviewLine1.style.color = option.querySelector('input').dataset.color;
                    embroideryPreviewLine2.style.color = option.querySelector('input').dataset.color;
                } else {
                    embroideryPreview.style.color = option.querySelector('input').dataset.color;
                }
            });
        });

        embroideryFontOptions.forEach(option => {
            if(option.classList.contains('selected')) {
                const font = option.querySelector('input').dataset.font;
                if(isFrame) {
                    embroideryPreviewLine1.style.fontFamily = font;
                    embroideryPreviewLine2.style.fontFamily = font;
                } else {
                    embroideryPreview.style.fontFamily = font;
                }
            }
            option.addEventListener('click', () => {
                if (option.hidden || option.querySelector('input')?.disabled) return;
                embroideryFontOptions.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                option.querySelector('input').checked = true;
                const font = option.querySelector('input').dataset.font;
                if(isFrame) {
                    embroideryPreviewLine1.style.fontFamily = font;
                    embroideryPreviewLine2.style.fontFamily = font;
                } else {
                    embroideryPreview.style.fontFamily = font;
                }
            });
        });
        

        embroideryConsentCheckboxes.forEach(checkbox => {
            const input = checkbox.querySelector('input');
            checkbox.addEventListener('click', event => {
                if (event.target !== input && !event.target.closest('label')) input.click();
            });
            input.addEventListener('change', () => {
                checkbox.classList.toggle('checked', input.checked);
                enableSubmitButton();
            });
        });
    }


    if (isFrame) {
        embroideryFrame()?.configure(/\bsmall\b/i.test(selectedVariant?.dataset.optionValueName || selectedVariantLabel?.textContent || ''));
    }
    enableSubmitButton();
    isModalInitialized = true

}


function enableSubmitButton() {
    const embroiderySubmitButton = embroideryRoot().querySelector('.js-embroidery-submit');
    const embroideryConsentCheckboxes = embroideryRoot().querySelectorAll('.js-embroidery-consent');
    const allChecked = Array.from(embroideryConsentCheckboxes).every(checkbox => checkbox.querySelector('input').checked);

    let textValid = isTextValid()
    const fontSelected = !!embroideryRoot().querySelector('.js-embroidery-font-option.selected input:not(:disabled)');

    if (allChecked && textValid && fontSelected) {
        embroiderySubmitButton.removeAttribute('disabled');
    } else {
        embroiderySubmitButton.setAttribute('disabled', 'disabled');
        
    }
}

function isEmbroideryTextInputValid(input) {
    return !!input && ((!input.required && !input.value.trim()) ||
        (input.value.trim().length > 0 && (input.maxLength < 0 || input.value.length <= input.maxLength)));
}

function isTextValid(){
    if (embroideryFrame()?.isDateMode()) return embroideryFrame().isValidDate();
    const first = embroideryRoot().querySelector('.js-embroidery-text-line-1') || embroideryRoot().querySelector('.js-embroidery-text');
    const second = embroideryRoot().querySelector('.js-embroidery-text-line-2');
    return isEmbroideryTextInputValid(first) && (!second || second.style.display === 'none' || isEmbroideryTextInputValid(second));
}

function displayTextValid() {

    const embroideryTextError = embroideryRoot().querySelector('.js-embroidery-text-error');
    const embroideryTextErrorLine2 = embroideryRoot().querySelector('.js-embroidery-text-error-line-2');

    if (embroideryFrame()?.isDateMode()) {
        embroideryTextError.style.display = 'none';
        embroideryRoot().querySelector('.js-frame-date-error').hidden = isTextValid();
        return;
    }

    const first = embroideryRoot().querySelector('.js-embroidery-text-line-1') || embroideryRoot().querySelector('.js-embroidery-text');
    const second = embroideryRoot().querySelector('.js-embroidery-text-line-2');
    embroideryTextError.style.display = isEmbroideryTextInputValid(first) ? 'none' : 'block';
    if (embroideryTextErrorLine2) {
        embroideryTextErrorLine2.style.display = second?.style.display !== 'none' && !isEmbroideryTextInputValid(second) ? 'block' : 'none';
    }
}

function setupEmbroidery() {

}

function addEmbroidery() {
    if (!cartEmbroideryContext && window.productAddOns && !window.productAddOns.ready(embroideryRoot().querySelector('.js-product-form'))) return;
    if (!isTextValid() || !embroideryRoot().querySelector('.js-embroidery-font-option.selected input:not(:disabled)') || !Array.from(embroideryRoot().querySelectorAll('.js-embroidery-consent input')).every(input => input.checked)) {
        displayTextValid();
        enableSubmitButton();
        return;
    }
    if (cartEmbroideryContext) return cartEmbroideryContext.save();
    const embroideryText = embroideryRoot().querySelector('.js-embroidery-text') ? embroideryRoot().querySelector('.js-embroidery-text').value : null;
    const embroideryTextLine1 = embroideryRoot().querySelector('.js-embroidery-text-line-1') ? (embroideryFrame()?.lineOneText() ?? embroideryRoot().querySelector('.js-embroidery-text-line-1').value) : null;
    const embroideryTextLine2 = embroideryFrame()?.isDateMode() ? '' : embroideryRoot().querySelector('.js-embroidery-text-line-2')?.value;
    const selectedColor = embroideryRoot().querySelector('.js-embroidery-color-option.selected input').value;
    const selectedFont = embroideryRoot().querySelector('.js-embroidery-font-option.selected input').value;
    const selectedPlacement = embroideryTextLine1 ? null :embroideryRoot().querySelector('.js-embroidery-placement-option.selected input').value;
    const selectedBackgroundColor = embroideryRoot().querySelector('.js-embroidery-background-color-option.selected input') ? embroideryRoot().querySelector('.js-embroidery-background-color-option.selected input').value : null;
    // Disabled product.metafields.custom.add_on
    // const selectedAddOn = embroideryRoot().querySelector('.js-embroidery-add-on-option.selected input') ? embroideryRoot().querySelector('.js-embroidery-add-on-option.selected input').value : null;
    // const selectedAddOnVariantId = embroideryRoot().querySelector('.js-embroidery-add-on-option.selected input') ? embroideryRoot().querySelector('.js-embroidery-add-on-option.selected input').dataset.variantId : null;

    const properties = embroideryRoot().querySelector('.js-embroidery-properties');
    const formId = properties.dataset.formId;
    embroideryFrame()?.saveSummary(formId);
    const propertyText = properties.querySelector('.js-property-embroidery-text') ? properties.querySelector('.js-property-embroidery-text') : null;
    const propertyTextLine1 = properties.querySelector('.js-property-embroidery-text-line-1') ? properties.querySelector('.js-property-embroidery-text-line-1') : null;
    const propertyTextLine2 = properties.querySelector('.js-property-embroidery-text-line-2') ? properties.querySelector('.js-property-embroidery-text-line-2') : null;
    const propertyColor = properties.querySelector('.js-property-embroidery-thread-color');
    const propertyFont = properties.querySelector('.js-property-embroidery-font');
    const propertyPlacement = properties.querySelector('.js-property-embroidery-placement') ? properties.querySelector('.js-property-embroidery-placement') : null;
    const propertyBackgroundColor = properties.querySelector('.js-property-embroidery-background-color') ? properties.querySelector('.js-property-embroidery-background-color') : null;
    // const propertyAddOn = properties.querySelector('.js-property-embroidery-add-on') ? properties.querySelector('.js-property-embroidery-add-on') : null;
    
    if(propertyText) {
        propertyText.setAttribute('form', formId);
        propertyText.value = embroideryText;

    }
    if(propertyTextLine1) {
        propertyTextLine1.setAttribute('form', formId);
        propertyTextLine1.value = embroideryTextLine1;
    }
    if(propertyTextLine2) {
        propertyTextLine2.setAttribute('form', formId);
        propertyTextLine2.value = embroideryTextLine2;
    }

    if(propertyPlacement) {
        propertyPlacement.setAttribute('form', formId);
        propertyPlacement.value = selectedPlacement;

    }

    if(propertyBackgroundColor) {
        propertyBackgroundColor.setAttribute('form', formId);
        propertyBackgroundColor.value = selectedBackgroundColor;
    }

    // Disabled product.metafields.custom.add_on
    // if(propertyAddOn) {
    //     propertyAddOn.setAttribute('form', formId);
    //     propertyAddOn.value = selectedAddOn;
    //     propertyAddOn.classList.remove('hidden');
    //     propertyAddOn.dataset.variantId = selectedAddOnVariantId;
    //     propertyAddOn.setAttribute('required', '');
    // } else {
    //     propertyAddOn.value = '';
    //     propertyAddOn.removeAttribute('form');
    //     propertyAddOn.classList.add('hidden');
    //     propertyAddOn.removeAttribute('data-variant-id');
    //     propertyAddOn.removeAttribute('required');
    // }

    propertyColor.setAttribute('form', formId);
    propertyFont.setAttribute('form', formId);

    // propertyColor.setAttribute('required', '');
    // propertyFont.setAttribute('required', '');
    // propertyPlacement.setAttribute('required', '');

    propertyColor.value = selectedColor;
    propertyFont.value = selectedFont;

    window.productAddOns?.saveSummary(embroideryRoot().querySelector('.js-product-form'), properties);
    properties.classList.remove('hidden');

    const productForm = embroideryRoot().querySelector('.js-product-form');
    productForm.classList.add('embroidery-added');


    const addEmbroideryText = embroideryRoot().querySelector('.js-add-embroidery-text');
    const editEmbroideryText = embroideryRoot().querySelector('.js-edit-embroidery-text');
    const removeEmbroideryButton = embroideryRoot().querySelector('.js-embroidery-remove');
    const quantity = embroideryRoot().querySelector('.js-quantity-selector');
    if(quantity) {
        quantity.classList.add('hidden');
    }
    removeEmbroideryButton.classList.remove('hidden');
    addEmbroideryText.classList.add('hidden');
    editEmbroideryText.classList.remove('hidden');


    closeEmbroideryModal(true);
}

function removeEmbroidery(preserveAddOns = false) {
    if (!preserveAddOns) window.productAddOns?.clearCustomization(document.querySelector('.js-product-form'));
    document.querySelector('[data-add-on-summary]')?.remove();
    window.frameCustomization?.clearSummary();
    const properties = document.querySelector('.js-embroidery-properties');
    const propertyText = properties.querySelector('.js-property-embroidery-text') ? properties.querySelector('.js-property-embroidery-text') : null;
    const propertyTextLine1 = properties.querySelector('.js-property-embroidery-text-line-1') ? properties.querySelector('.js-property-embroidery-text-line-1') : null;
    const propertyTextLine2 = properties.querySelector('.js-property-embroidery-text-line-2') ? properties.querySelector('.js-property-embroidery-text-line-2') : null;
    const propertyColor = properties.querySelector('.js-property-embroidery-thread-color');
    const propertyFont = properties.querySelector('.js-property-embroidery-font');
    const propertyBackgroundColor = properties.querySelector('.js-property-embroidery-background-color') ? properties.querySelector('.js-property-embroidery-background-color') : null;
    const propertyPlacement = properties.querySelector('.js-property-embroidery-placement') ? properties.querySelector('.js-property-embroidery-placement') : null;
    // Disabled product.metafields.custom.add_on
    // const propertyAddOn = properties.querySelector('.js-property-embroidery-add-on') ? properties.querySelector('.js-property-embroidery-add-on') : null;

    if(propertyText) {
        propertyText.value = '';
        propertyText.removeAttribute('form');
    }
    if(propertyTextLine1) {
        propertyTextLine1.value = '';
        propertyTextLine1.removeAttribute('form');
    }
    if(propertyTextLine2) {
        propertyTextLine2.value = '';
        propertyTextLine2.removeAttribute('form');
    }

    if(propertyPlacement) {
        propertyPlacement.value = '';
        propertyPlacement.removeAttribute('form');
    }

    if(propertyBackgroundColor) {
        propertyBackgroundColor.value = '';
        propertyBackgroundColor.removeAttribute('form');
    }

    // Disabled product.metafields.custom.add_on
    // if(propertyAddOn) {
    //     propertyAddOn.value = '';
    //     propertyAddOn.removeAttribute('form');
    //     propertyAddOn.classList.add('hidden');
    //     propertyAddOn.removeAttribute('data-variant-id');
    //     propertyAddOn.removeAttribute('required');
    // }

    properties.classList.add('hidden');

    propertyColor.value = '';
    propertyFont.value = '';
    propertyColor.removeAttribute('form');
    propertyFont.removeAttribute('form');

    // propertyText.removeAttribute('required');
    // propertyColor.removeAttribute('required');
    // propertyFont.removeAttribute('required');
    // propertyPlacement.removeAttribute('required');

    const productForm = document.querySelector('.js-product-form');
    productForm.classList.remove('embroidery-added');

    const addEmbroideryText = document.querySelector('.js-add-embroidery-text');
    const editEmbroideryText = document.querySelector('.js-edit-embroidery-text');
    const removeEmbroideryButton = document.querySelector('.js-embroidery-remove');
    const quantity = document.querySelector('.js-quantity-selector');
    if(quantity){
        quantity.classList.remove('hidden');
    }
    removeEmbroideryButton.classList.add('hidden');
    addEmbroideryText.classList.remove('hidden');
    editEmbroideryText.classList.add('hidden');
}

function addEmbroideryToCart() {
    const activeForm = document.querySelector('.js-product-form');
    if (activeForm.dataset.addingCustomization === 'true') return;
    let properties = document.querySelector('.js-embroidery-properties');
    let propertyText = properties.querySelector('.js-property-embroidery-text') ? properties.querySelector('.js-property-embroidery-text').value : null;
    let propertyTextLine1 = properties.querySelector('.js-property-embroidery-text-line-1') ? properties.querySelector('.js-property-embroidery-text-line-1').value : null;
    let propertyTextLine2 = properties.querySelector('.js-property-embroidery-text-line-2') ? properties.querySelector('.js-property-embroidery-text-line-2').value : null;
    let propertyColor = properties.querySelector('.js-property-embroidery-thread-color').value;
    let propertyFont = properties.querySelector('.js-property-embroidery-font').value;
    let propertyBackgroundColor = properties.querySelector('.js-property-embroidery-background-color') ? properties.querySelector('.js-property-embroidery-background-color').value : null;
    let propertyPlacement = properties.querySelector('.js-property-embroidery-placement') ? properties.querySelector('.js-property-embroidery-placement').value : null;
    let embroideryProduct = properties.querySelector('.js-embroidery-product-id').value;
    let isFrame = document.querySelector('#embroidery-form').dataset.isFrame == 'true' ? true : false;
    // Disabled product.metafields.custom.add_on
    // let propertyAddOn = properties.querySelector('.js-property-embroidery-add-on').value != 'none' ? properties.querySelector('.js-property-embroidery-add-on').value : null;
    // let propertyAddOnVariantId = properties.querySelector('.js-property-embroidery-add-on') ? properties.querySelector('.js-property-embroidery-add-on').dataset.variantId : null;
    
    if (propertyFont && isEmbroideryFontRestricted(propertyFont)) {
        removeEmbroidery(true);
        alert('The selected embroidery font is not available for this color or pattern. Please add the embroidery again and choose another font.');
        return;
    }

    if(isFrame) {
        if(propertyTextLine1 == '' || propertyColor == '' || propertyFont == '' || propertyBackgroundColor == '') {
            alert('There was an error adding the customized product to the cart. Please try again. If you continue to experience issues, please contact us.');
            location.reload();
            return
        }
    } else {
        if(propertyText == '' || propertyColor == '' || propertyFont == '' || propertyPlacement == '') {
            alert('There was an error adding the embroidery to the cart. Please try again. If you continue to experience issues, please contact us.');
            location.reload();
            return
        }
    }

    let productForm = document.querySelector('.js-product-form');
    let productId = productForm.querySelector('input[name="id"]').value;
    let quantity = document.querySelector('input[name="quantity"]').value;
    let product = document.querySelector('.js-product-title');
    let productTitle = product.textContent;
    let variantPicker = document.querySelector('.variant-picker');

    if (variantPicker) {
        let selectedVariantInputs = variantPicker.querySelectorAll('input:checked');

        selectedVariantInputs.forEach(variant => {
            let label = document.querySelector(`label[for="${variant.id}"] span`);
            if (label) {
                productTitle += ` - ${label.innerHTML}`;
            }
        });
    }

    // create unique identifier for the embroidery product
    let randomNumber = Math.floor(Math.random() * 1000000);
    let uniqueIdentifier = propertyTextLine1 ? `${productId}-${propertyTextLine1}-${propertyTextLine2}-${propertyColor}-${propertyFont}--${randomNumber}` : `${productId}-${propertyText}-${propertyColor}-${propertyFont}-${propertyPlacement}-${randomNumber}`;

    // Disabled product.metafields.custom.add_on
    // if(propertyAddOn) {
    //     uniqueIdentifier += `-${propertyAddOn}-${propertyAddOnVariantId}`;
    // }

    let formData = '';

    if(propertyTextLine1) {
        // Disabled product.metafields.custom.add_on
        // if(propertyAddOn) {
        //     formData = {
        //         'items': [{
        //             'id': parseInt(productId),
        //             'quantity': parseInt(quantity),
        //             'properties': {
        //                 'Custom Text Line 1': propertyTextLine1,
        //                 'Custom Text Line 2': propertyTextLine2,
        //                 'Thread Color': propertyColor,
        //                 'Font': propertyFont,
        //                 'Background Color': propertyBackgroundColor,
        //                 'Add On': propertyAddOn,
        //                 '_product_match': uniqueIdentifier
        //             }
        //         },
        //         {
        //             'id': parseInt(propertyAddOnVariantId),
        //             'quantity': parseInt(quantity),
        //             'properties': {
        //                 'For': productTitle,
        //                 '_variant_id': propertyAddOnVariantId,
        //                 '_product_match': uniqueIdentifier,
        //             }
        //         }]
        //     }
        // } else {
            formData = {
                'items': [{
                    'id': parseInt(productId),
                    'quantity': parseInt(quantity),
                    'properties': {
                        'Custom Text Line 1': propertyTextLine1,
                        'Custom Text Line 2': propertyTextLine2,
                        'Thread Color': propertyColor,
                        'Font': propertyFont,
                        'Background Color': propertyBackgroundColor,
                    }
                }]
            }
        // }
    } else {
        formData = {
            'items': [{
                'id': parseInt(productId),
                'quantity': parseInt(quantity),
                'properties': {
                    'Embroidery Text': propertyText,
                    'Thread Color': propertyColor,
                    'Font': propertyFont,
                    'Placement': propertyPlacement,
                    '_product_match': uniqueIdentifier
                }
            },
            {
                'id': parseInt(embroideryProduct),
                'quantity': parseInt(quantity),
                'properties': {
                    'For': productTitle,
                    '_variant_id': productId,
                    '_product_match': uniqueIdentifier,
                }
            }]
        };
    }



    if (isFrame && productForm.querySelector('[name="properties[_customization_type]"]')?.value === 'customization-text') {
        formData.items[0].properties._customization_type = 'customization-text';
    }
    const customizationType = properties.querySelector('.js-property-frame-type')?.value;
    if (isFrame && customizationType) {
        formData.items[0].properties['Customization Type'] = customizationType;
    }
    if (window.productAddOns) {
        formData.items = window.productAddOns.appendItems(productForm, formData.items);
    }
    const requestedSections = window.loulouCart.prepareSections();
    productForm.dataset.addingCustomization = 'true';
    const submitButton = productForm.querySelector('.js-embroidery-atc-btn');
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.setAttribute('data-atc-loading', 'true');

    let added = false;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add these items. Please try again.');
        added = true;
        removeEmbroidery();
        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
            window.location.href = `${Shopify.routes.root}cart`;
            return;
        }
        const cart = await window.loulouCart.getCart(data, requestedSections);
        window.loulouCart.notifyAdded(productForm, data, cart, productForm.querySelector('[name="on_success"]')?.value);
    })
    .catch((error) => {
        console.error('Error:', error);
        productForm.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: added ? 'Your items were added, but the cart could not refresh. Open the cart to review them.' : error.message || 'Unable to add these items. Please try again.' }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .finally(() => {
        delete productForm.dataset.addingCustomization;
        submitButton.removeAttribute('aria-busy');
        submitButton.removeAttribute('data-atc-loading');
    });
}

function resetEmbroideryTextFields() {
    window.frameCustomization?.reset();
    const embroideryText = document.querySelector('.js-embroidery-text');
    const embroideryTextLine1 = document.querySelector('.js-embroidery-text-line-1');
    const embroideryTextLine2 = document.querySelector('.js-embroidery-text-line-2');
    const embroideryPreview = document.querySelector('.js-embroidery-text-preview');
    const embroideryPreviewLine1 = document.querySelector('.js-embroidery-text-preview-line-1');
    const embroideryPreviewLine2 = document.querySelector('.js-embroidery-text-preview-line-2');

    if (embroideryText) {
        embroideryText.value = '';
    }
    if (embroideryTextLine1) {
        embroideryTextLine1.value = '';
    }
    if (embroideryTextLine2) {
        embroideryTextLine2.value = '';
    }
    if (embroideryPreview) {
        embroideryPreview.innerHTML = '';
    }
    if (embroideryPreviewLine1) {
        embroideryPreviewLine1.innerHTML = '';
    }
    if (embroideryPreviewLine2) {
        embroideryPreviewLine2.innerHTML = '';
    }
}

function refreshEmbroideryAfterVariantChange(resetFields = true) {
    if (cartEmbroideryContext) return;
    const productForm = document.querySelector('.js-product-form');
    const variant = productForm?.querySelector('input[name="id"]');
    const embroideryWrapper = document.querySelector('.embroidery-btn-wrapper');
    const embroideryForm = document.querySelector('#embroidery-form');
    if (!productForm || !variant || !embroideryWrapper || !embroideryForm) return;

    if (resetFields) resetEmbroideryTextFields();
    applyEmbroideryFontRestrictions();

    const savedFont = document.querySelector('.js-property-embroidery-font')?.value;
    if (productForm.classList.contains('embroidery-added') && isEmbroideryFontRestricted(savedFont)) {
        removeEmbroidery(true);
    }

    const addToCartButton = productForm.querySelector('.buy-buttons button[type="submit"]');
    const embroideryAtcButton = productForm.querySelector('.js-embroidery-atc-btn');
    if (embroideryAtcButton && addToCartButton) {
        embroideryAtcButton.disabled = addToCartButton.disabled;
        embroideryAtcButton.innerText = addToCartButton.disabled ? 'Sold Out' : 'Add to Cart';
    }

    if (variantsToHideEmbroidery.includes(parseInt(variant.value))) {
        productForm.classList.add('embroidery-hidden');
        embroideryWrapper.style.display = 'none';
    } else {
        embroideryWrapper.style.display = 'flex';
        productForm.classList.remove('embroidery-hidden');
    }
}

function guardEmbroideryProductSubmit(event) {
    if (cartEmbroideryContext) return;
    const productForm = event.target.closest?.('.js-product-form');
    if (!productForm || productForm.closest('quick-buy-modal') || productForm.querySelector('[data-fixed-design-mode]')) return;

    const embroideryForm = document.querySelector('#embroidery-form');
    if (!embroideryForm) return;

    // Leave unrelated submit controls, such as wishlist app buttons, alone.
    if (event.submitter && !event.submitter.closest('buy-buttons')) return;

    const isFrame = embroideryForm.dataset.isFrame === 'true';
    const hasCustomization = productForm.classList.contains('embroidery-added');
    const customizationHidden = productForm.classList.contains('embroidery-hidden');
    if (customizationHidden || (!isFrame && !hasCustomization)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (hasCustomization) {
        addEmbroideryToCart();
    } else {
        openEmbroideryModal();
    }
}

function initVariantChangeListener() {
    if (!document.querySelector('#embroidery-form') || !document.querySelector('.js-product-form')) return;
    if (!embroiderySubmitGuardInitialized) {
        embroiderySubmitGuardInitialized = true;
        document.addEventListener('submit', guardEmbroideryProductSubmit, true);
    }
    if (!document.querySelector('.embroidery-btn-wrapper')) return;

    refreshEmbroideryAfterVariantChange(false);
    if (embroideryVariantListenerInitialized) return;
    embroideryVariantListenerInitialized = true;

    document.addEventListener('change', event => {
        if (!event.target.matches('.js-product-form input[name="id"]')) return;
        const isFrame = document.querySelector('#embroidery-form')?.dataset.isFrame === 'true';
        refreshEmbroideryAfterVariantChange();
        if (isFrame) removeEmbroidery(true);
    });

    // Shopify replaces variant and buy-button markup after this non-bubbling event.
    // Capture it on document and run after the synchronous replacement completes.
    document.addEventListener('product:rerender', event => {
        if (!event.target.matches('.js-product-form')) return;
        queueMicrotask(() => refreshEmbroideryAfterVariantChange(false));
    }, true);
}
